const MENU_CURATION_TASK_STATUS = {
  AWAITING_WORK: { value: 'AWAITING_WORK', label: 'Awaiting work' },
  TIER_ONE_IN_PROGRESS: {
    value: 'TIER_ONE_IN_PROGRESS',
    label: 'Tier one in progress',
  },
  AWAITING_SCRAPING_REVIEW: {
    value: 'AWAITING_SCRAPING_REVIEW',
    label: 'Awaiting scraping review',
  },
  SCRAPING_REVIEW_IN_PROGRESS: {
    value: 'SCRAPING_REVIEW_IN_PROGRESS',
    label: 'Scraping review in progress',
  },
  AWAITING_AUTOEAT_UPDATES: {
    value: 'AWAITING_AUTOEAT_UPDATES',
    label: 'Awaiting autoeat updates',
  },
  NEEDS_SCRAPING_CLARIFICATION: {
    value: 'NEEDS_SCRAPING_CLARIFICATION',
    label: 'Needs scraping clarification',
  },
  UNKNOWN_WORDS_CURATION_IN_PROGRESS: {
    value: 'UNKNOWN_WORDS_CURATION_IN_PROGRESS',
    label: 'Unknown words curation in progress',
  },
  UNKNOWN_WORDS_QA_IN_PROGRESS: {
    value: 'UNKNOWN_WORDS_QA_IN_PROGRESS',
    label: 'Unknown words QA in progress',
  },
  CURATION_IN_PROGRESS: {
    value: 'CURATION_IN_PROGRESS',
    label: 'Curation in progress',
  },
  QA_IN_PROGRESS: { value: 'QA_IN_PROGRESS', label: 'Qa in progress' },
  QC_IN_PROGRESS: { value: 'QC_IN_PROGRESS', label: 'Qc in progress' },
  RESOLVED: {
    value: 'RESOLVED',
    label: 'Resolved',
  },
  AUTOMATICALLY_RESOLVED: {
    value: 'AUTOMATICALLY_RESOLVED',
    label: 'Automatically Resolved',
  },
}

module.exports = MENU_CURATION_TASK_STATUS
